import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ButtonsUseStyles from 'consts/styles/Buttons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { UAVOS_SOURCES, UAVOS_SOURCES_TYPES } from 'consts/mapConfig';

import { FiltersDetailsUseStyles } from './FiltersDetailsUseStyles';

const UavosFilter = props => {
  const { dronesFiltersTypes, language } = props;

  const classesFilters = FiltersDetailsUseStyles();
  const classesButtons = ButtonsUseStyles();

  const [filters, setFilters] = React.useState(
    UserSessionDataHandler.getUavosFilters()
  );
  const [showDronesFiltersFlag, setShowDronesFiltersFlag] = React.useState(
    (filters.indexOf('aircraft') >= 0 && filters.length > 1) ||
      (filters.indexOf('aircraft') < 0 && filters.length > 0)
  );

  const isDronesFilterSelected = source => filters.includes(source);

  React.useEffect(() => {
    UserSessionDataHandler.saveTmpFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const toggleSource = source => {
    if (source === UAVOS_SOURCES_TYPES.drones) {
      if (showDronesFiltersFlag) {
        removeAllDronesSources();
        setShowDronesFiltersFlag(false);
      } else setShowDronesFiltersFlag(true);

      return;
    }
    const indexOfSource = filters.indexOf(source);
    const sources = [...filters];

    if (indexOfSource === -1) sources.push(source);
    else sources.splice(indexOfSource, 1);

    setFilters(sources);
  };

  const removeAllDronesSources = () => {
    const aircraftsOn = filters.indexOf('aircraft');
    if (aircraftsOn >= 0) setFilters([UAVOS_SOURCES.aircrafts]);
    else setFilters([]);
  };

  const isSelected = source => {
    if (source === UAVOS_SOURCES_TYPES.aircrafts)
      return filters.includes(UAVOS_SOURCES_TYPES.aircrafts);
    return showDronesFiltersFlag;
  };

  const buttons = Object.keys(UAVOS_SOURCES_TYPES).map((source, index) => (
    <Button
      key={index}
      type="button"
      className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
      variant={
        isSelected(UAVOS_SOURCES_TYPES[source]) ? 'contained' : 'outlined'
      }
      onClick={() => toggleSource(UAVOS_SOURCES_TYPES[source])}
      color='primary'
    >
      {language.filters.uavos[`${source}_`]}
    </Button>
  ));

  const dronesFilterButtons = dronesFiltersTypes.map((source, index) => (
    <Button
      key={index}
      type="button"
      className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
      variant={isDronesFilterSelected(source) ? 'contained' : 'outlined'}
      onClick={() => toggleSource(source)}
      color='primary'

    >
      {source}
    </Button>
  ));

  return (
    <div>
      <div className={`${classesFilters.FiltersDetails}__table__details`}>
        {language.filters.uavos.type_}
        <div
          className={`${classesFilters.FiltersDetails}__table__details__container`}
        >
          {buttons}
        </div>
      </div>

      <div className={`${classesFilters.FiltersDetails}__table__details`}>
        {language.filters.uavos.header_}
        {showDronesFiltersFlag ? (
          <div
            className={`${classesFilters.FiltersDetails}__table__details__container`}
          >
            {dronesFilterButtons}
          </div>
        ) : (
          <div
            className={`${classesFilters.FiltersDetails}__table__details__container`}
          >
            <Button
              type="button"
              className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
              disabled
            >
              {language.filters.uavos.noData_}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

UavosFilter.propTypes = {
  dronesFiltersTypes: PropTypes.array.isRequired,
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  dronesFiltersTypes: state.dronesFiltersTypes,
  language: state.language,
});

export default connect(mapStateToProps)(UavosFilter);
